import React from 'react';
import {t} from '@lingui/core/macro';

import ErrorPage from './ErrorPage';

export default function NotFoundPage() {
    return (
        <ErrorPage
            code={404}
            description={<>{t`Ошибка`} 404.<br/> {t`Нет такой страницы`}!</>}
            linkTo="/"
            linkLabel={t`На главную`}
        />
    );
}
